export class LocationsLayerHook {
}
